// extracted by mini-css-extract-plugin
module.exports = {"text":"OverlayTitle_text_25Yd9","line":"OverlayTitle_line_Cgt6w"};